'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPTY_DELETE = exports.EMPTY_DELETE = 'empty-delete';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/deleteOnEmpty/commandConstants.js
// module id = 683
// module chunks = 0